export const FALLBACK_BAGCONTENTS_PHRASES = {
  brick: ["brick", "bricks", "blocks"],
  plasterboard: ["plasterboard"],
  rubble: ["rubble", "blocks of rubble"],
  soil: ["soil", "dirt"],
  tiles: ["tiles"],
  "garden waste": ["garden waste"],
  "general waste": ["general waste"],
  cardboard: ["cardboard"],
  wood: ["wood", "mdf"],
};
